
import {useState,useEffect} from 'react'
import {useNavigate , useLocation} from "react-router-dom";
import SendData from "./SendData"
import Switch from "./components/Switch"


function Modal ({titr,items,onChange,onClose}){
  return (
    <div className="modal"  /*style={overlayerStyle}*/>
      <h2 style={{textAlign:'center'}} >
        {titr}
      </h2>
      {items}
    </div>
  );
}

const overlayerStyle = {
  position:'fixed',
  top:0,
  left:0,
  right:0,
  bottom:0,
  background: "rgba (0,0,0,0,5)",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex:1000
};

const modalStyle = {
  background: '#fff',
  padding:20,
  borderRadius:8,
  width:'80%',
  maxWidth:300
};



function PhoneSetting ({socket}){
  const location = useLocation ();
  const [name,setName] = useState (/*location.state.name*/);

  const [phones,setPhones] = useState (location.state.phones);
  const [mode,setMode] = useState ([]);
  const [select,setSelect] = useState (-1);
  const [modalShow_delete,setModalShow_delete] = useState (false);
  const [modalShow,setModalShow] = useState (false);
  const [number,setNumber] = useState ("");
  const [call,setCall]= useState (true);
  const [message,setMessage]= useState (true);
  const [app,setApp]= useState (true);
  const [setting,setSetting]= useState (true);


  const navigate = useNavigate ();
  useEffect (()=>{
    if (location.state.mode!=undefined)
      setMode   (location.state.mode);

  return () =>{
    socket.off ('message');
  };
},[socket]);

  return (
    <div style={style.container}>
    {
      modalShow_delete && (
    <Modal
      titr={"میخواهید شماره"+'  '+phones[select]+'  '+'را حذف نمایید'}
      items={
        <div>
          <div style={{flex:1}}  className="row"  >
          <button   className='btn'
            onClick={()=>{
              var a=phones; a.splice(select, 1); setPhones (a); setSelect (-1);
              setModalShow_delete (false)
            }} >
            بله
          </button>
          <button   className='btn'
            onClick={()=>{
              setModalShow_delete (false)
            }} >
            خیر
          </button>
          </div>

          </div>
      }
     /> )}


     {
       modalShow && (
     <Modal
       titr="شماره موبایل"
       items={
         <div style={{ margin:10,padding:10, borderRadius:10 , backgroundColor:'white' , }}>
           <input style={style.input}
           type="tel"
           placeholder = ""
           value={number}
           onChange = {(e)=>{setNumber (e.target.value)}}/>

           <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row'  }}>
           <Switch
               type='checkbox'
               style={{ padding: 8}}
               value={app}
               checkedCheckBoxColor={'#60b'}
               uncheckedCheckBoxColor={'#09f'}
               onChange={()=>{
                 setApp (!app);
               }}
           />
           <h2 style={{ fontSize:20 , alignSelf:'center' ,margin:10 }} >استفاده از برنامه</h2>
           </div>
           <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row'  }}>
           <Switch
               type='checkbox'
               style={{ padding: 8}}
               value={setting}
               checkedCheckBoxColor={'#60b'}
               uncheckedCheckBoxColor={'#09f'}
               onChange={()=>{
                 setSetting (!setting)
               }}
           />
           <h2 style={{ fontSize:20 , alignSelf:'center' ,margin:10 }} >دسترسی به تنظیمات</h2>
           </div>

           <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row'  }}>
           <Switch
               type='checkbox'
               style={{ padding: 8}}
               value={message}
               checkedCheckBoxColor={'#60b'}
               uncheckedCheckBoxColor={'#09f'}
               onChange={()=>{
                 setMessage (!message);
               }}
           />
           <h2 style={{ fontSize:20 , alignSelf:'center' ,margin:10 }} >ارسال پیامک</h2>
           </div>
           <div className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row'  }}>
           <Switch
               type='checkbox'
               style={{ padding:8}}
               value={call}
               checkedCheckBoxColor={'#60b'}
               uncheckedCheckBoxColor={'#09f'}
               onChange={()=>{
                 setCall (!call);
               }}
           />
           <h2 style={{ fontSize:20 , alignSelf:'center' ,margin:10 }} >ارسال تماس</h2>
           </div>

           <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row'  }}>

           <div  style={{ margin:10  ,flex:.5 }}>
           <button className='btn'
              onClick={() => {
                if (number.length!=11)window.alert ('شماره تلفن باید یازده رقم باشد');
                else if (number[0]!='0' || number[1]!='9')window.alert ('شماره اشتباه وارد شده است');
                else
                {
                  if (select>=0)
                  {
                    var a=phones;
                    a[select]=number;
                    setPhones (a);
                    var b=mode;
                    b[select]={call:call,message:message,app:app,setting:setting};
                    setMode (b);
                  }else {
                    var a=phones;
                    a[a.length]=number;
                    setPhones (a);
                    var b=mode;
                    b.push ({call:call,message:message,app:app,setting:setting});
                    setMode (b);
                  }
                  setModalShow (false);
               }
              }}
              >
              تایید
              </button>
            </div>
            <div  style={{ margin:10  ,flex:.5 }}>
            <button className='btn' style={{fontSize:20,flex:.4,margin:10}}
                 onClick={() => { setModalShow (false); }}
              >
              کنسل
              </button>
              </div>
           </div>
         </div>
       }
      /> )}




      <div style={style.content}>
        <h2 style={style.text}>
          تنظیم تلفن ها
        </h2>


    <div style={{backgroundColor:'white',padding:10}}>
    {

      phones.map( (value,key) => {
         return (
           <div className='row' key={key} style={{borderRadius:10, backgroundColor:(select==key)?'#09f':'#00f0',justifyContent: 'space-between', flex:1, padding:5 ,flexDirection:'row' }}
             onClick={()=>{
               setSelect (key);
             }}
           >
           <h2 style={{color:(select==key)?'white':'#09f', fontSize:20,flex:.5, fontStyle: "italic",textAlign:"center" }}>
           {value}
           </h2>
           <Switch
               type='checkbox'
               style={{ padding: 1}}
               value={(mode[key]!=undefined ) ? mode[key].app : 1}
               checkedCheckBoxColor={'#60b'}
               uncheckedCheckBoxColor={'#60b'}
               onChange={()=>{
               }}
           />

           <Switch
               type='checkbox'
               style={{ padding: 1}}
               value={(mode[key]!=undefined) ? mode[key].setting : 1}
               checkedCheckBoxColor={'#60b'}
               uncheckedCheckBoxColor={'#60b'}
               onChange={()=>{
               }}
           />
           <Switch
               type='checkbox'
               style={{ padding: 1}}
               value={(mode[key]!=undefined) ? mode[key].message :1}
               checkedCheckBoxColor={'#60b'}
               uncheckedCheckBoxColor={'#60b'}
               onChange={()=>{
               }}
           />
           <Switch
               type='checkbox'
               style={{ padding: 1}}
               value={(mode[key]!=undefined) ? mode[key].call : 1}
               checkedCheckBoxColor={'#60b'}
               uncheckedCheckBoxColor={'#60b'}
               onChange={()=>{
               }}
           />

           </div>
         )

       })
     }
     </div>

     </div>


     <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row' ,flex:1 }}>
     <div  style={{ margin:10  ,flex:1/3 }}>
     <button className="btn"
        title="افزودن"
        onClick={() => {
          if (phones.length>=5) window.alert ('امکان افزایش شماره وجود ندارد');
          else {
            setSelect (-1);
            setNumber ('');
            setApp (true);
            setSetting (false);
            setMessage (false);
            setCall (false);
            setModalShow (true);
         }
       }}
        >
        افزودن
        </button>
      </div>
      <div  style={{ margin:10  ,flex:1/3 }}>
      <button className="btn" style={{fontSize:20,flex:.4,margin:10}}
           title="ویرایش"
           onClick={() => { if (select>=0){
             setNumber (phones[select]);
             if (mode[select]!=undefined)
             {
               setApp (mode[select].app);
               setSetting (mode[select].setting);
               setMessage (mode[select].message);
               setCall (mode[select].call);
             }
             else {
               {
                  setApp (true);
                  setSetting (true);
                  setCall (true);
                  setMessage (true);

               }
             }
             setModalShow (true);
           }}}
        >
        ویرایش
        </button>
        </div>
        <div  style={{ margin:10  ,flex:1/3  }}>
      <button className="btn" style={{fontSize:20,flex:.2,margin:10}}
              title="حذف"
              onClick={() => {
                if (select>=0)
                  setModalShow_delete (true);
              }}
        >
        حذف
        </button>
        </div>
    </div>







    <button className="btn"
      onClick ={()=>{
      socket.off ('message');
      socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="SAVE_PHONES" && JSON.parse(data).data==true)
            {
              window.alert ('اطلاعات با موفقیت ذخیره شد');
              socket.off ('message');
              navigate (-1);
            }
        });
        SendData (socket,'data',{
          "event":"set_phones",
          "data":{"phones":phones,"mode":mode}
        });
      }}>
       تایید
    </button>
    </div>
  );


}
const style={
  container:{
    width:"90%",
    minHeight:"100vh",
//    display:"flex",
    alignItems:"center",
    padding:10,

//    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
     maxWidth:820,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10,
    padding:10,
    backgroundColor:"#00afff",
    borderRadius:8
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:20,
    borderRadius:8,
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:820,
    padding:4,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
    padding:0,
    margin:10,
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default PhoneSetting;
